export default __webpack_public_path__ + "static/media/aliExpress (2).ba65ac12.png";